import React from "react";
import { useFormikContext } from "formik";

export const FormikSave = props => {
    const formik = useFormikContext();
    return (
        <>
            <button
                {...props}
                style={
                    !formik.isValid || !formik.dirty || !formik.values.files?.length
                        ? { backgroundColor: "#A4A3A5" }
                        : {
                              backgroundColor: "#F2F59D",
                              color: "#006465",
                              borderColor: "#F2F59D",
                          }
                }
            >
                {formik.isSubmitting ? <span>Guardando...</span> : <span>Guardar</span>}
            </button>
            {formik.dirty && !formik.isValid && (
                <span className="text-yellow ml-2"> Faltan datos o no son válidos.</span>
            )}
        </>
    );
};
